import { ICreateUser, IPatchUser, IUser, Roles } from '@cod-monorepo/interfaces';

export class LoadUsers {
    static readonly type = '[Users] Load Users';
}

export class LoadAssignableUsers {
    static readonly type = '[Users] Load Assignable Users';
    constructor(public role: Roles) {}
}

export class LoadCsrUsers {
    static readonly type = '[Users] Load CSR Users';
}

export class LoadManagerUsers {
    static readonly type = '[Users] Load Manager Users';
}

export class LazyLoadUsers {
    static readonly type = '[Users] Lazy Load Users';
}

export class SetSearchTerm {
    static readonly type = '[Users] Set Search Term';
    constructor(public searchTerm: string) {}
}

export class UpdateUser {
    static readonly type = '[Users] Update User';
    constructor(public gid: string, public user: IPatchUser) {}
}

export class DeleteUser {
    static readonly type = '[Users] Delete User';
    constructor(public gid: string) {}
}

export class CreateUser {
    static readonly type = '[Users] Create User';
    constructor(public user: ICreateUser) {}
}

export class SetUser {
    static readonly type = '[Users] Set User';
    constructor(public readonly payload: { user: IUser }) {}
}

export class LoadProfilePicture {
    static readonly type = '[Users] Load Profile Picture';
}

export class QueryUsers {
    static readonly type = '[Users] Query User';
    constructor(public search: string, public page: number) {}
}
